import { useState } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'

export function useDialogState() {
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))

  const [open, setOpen] = useState(false)

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  return {
    open,
    handleOpen,
    handleClose,
    DialogProps: { fullScreen, open, onClose: handleClose },
  }
}
